module.exports = __webpack_public_path__ + "img/video_img2.64590ae2.png";